import OperationParameterTableConfig from "../OperationParametrTableConfig";

const fields = (t) => ({
    config: {columns: 2},
    fields: [
        {
            name: "id",
            column: 1,
            type: "unvisible",
        },
        {
            name: "name",
            label: t ? t("common.group_name") : "Nazwa grupy",
            column: 1,
            type: "text",
            mandatory: true,
        },
        {
            name: "operatingParameterTemplates",
            label: t ? t("object_types.operating_parameter_template") : "Parametry pracy",
            type: "table",
            tableConfig: {
                api: "operatingParameterTemplate",
                columns: OperationParameterTableConfig(t),
                checked: true
            },
        },
    ]
});

export default fields;
